import { Component, ElementRef, Input, OnDestroy, OnInit, ViewChild } from '@angular/core'
import { ClientTopServices } from '../../../../../../services/ClientTop.services'
import { getImageRedirectUrl } from '../../../../../../../helper/common'

@Component({
    selector: 'app-modal-client-detail-slideshow-dsd',
    templateUrl: './modal-client-detail-slideshow-dsd.component.html',
    styleUrls: [
        '../../../../../../stagingcss/canvas.component.css',
        './modal-client-detail-slideshow-dsd.component.css'],
    host: {
        '(window:resize)': 'onResize($event)',
    },
})
export class ModalClientDetailSlideshowDsdComponent implements OnInit, OnDestroy {
    @ViewChild('canvasImg') canvasImg: ElementRef
    @ViewChild('rangeTop') rangeTop: ElementRef
    @Input() type: string
    imgShow = false
    canvasHeight = '300px'
    changeEmittedIndex: any
    changeEmittedAllArrClientTo: any
    slideshowData = []
    index = 0
    previousIndex = 0
    urlImg = ''
    selectDate = 0
    page = ''

    constructor(public clientTopServices: ClientTopServices) {
    }

    ngOnInit() {
        this.setCanvasDimension()
        this.getArrClientTop()
    }

    ngOnDestroy() {
        if(this.changeEmittedIndex)
            this.changeEmittedIndex.unsubscribe()
        if(this.changeEmittedAllArrClientTo)
            this.changeEmittedAllArrClientTo.unsubscribe()
        this.page = ''
    }

    onResize(event) {
        this.setCanvasDimension()
    }

    setCanvasDimension() {
        this.canvasHeight = Math.round(this.canvasImg.nativeElement.offsetWidth * 720 / 1280) + 'px'
    }

    getArrClientTop() {
        this.changeEmittedIndex = this.clientTopServices.changeEmittedIndex$.subscribe((index) => {
            this.page = this.clientTopServices.returnPage()
            this.changeEmittedAllArrClientTo = this.clientTopServices.changeEmittedAllArrClientTo$.subscribe(res => {
                if (this.page == 'slideshow') {
                    this.inititalClientTop(res)
                }
            })
        })
    }

    inititalClientTop(res) {
        this.imgShow = false
        this.index = this.clientTopServices.getIndex()
        if (res && res.slideshow && res.slideshow.length > 0 && this.index != null) {
            this.slideshowData = res['slideshow']
            this.slideshowData.sort(function(a, b) {
                return a.dateStringToInit - b.dateStringToInit
            })
            if (this.slideshowData.length > 1) {
                this.rangeTop.nativeElement.setAttribute('max', 100)
                this.selectDate = this.index * Math.round(100 / (this.slideshowData.length - 1))
            } else {
                this.rangeTop.nativeElement.setAttribute('max', 0)
                this.selectDate = 0
            }
            if (this.type == 'dsd') {
                if (res.slideshow[this.index] && res.slideshow[this.index].dsd && JSON.stringify(this.slideshowData[this.index].dsd) != '{}') {
                    this.urlImg = getImageRedirectUrl(this.slideshowData[this.index].dsd.canvasImgDemo)
                    this.imgShow = true
                }
            } else if (this.type == 'smile') {
                if (res.slideshow[this.index] && res.slideshow[this.index].smile && JSON.stringify(this.slideshowData[this.index].smile) != '{}') {
                    this.urlImg = getImageRedirectUrl(this.slideshowData[this.index].smile.canvasImgDemo)
                    this.imgShow = true
                }
            }
        } else {
            this.rangeTop.nativeElement.setAttribute('max', 0)
            this.selectDate = 0
            this.clientTopServices.emitChangeSlider(0)
        }
    }

    changeDate() {
        const dataLength = this.slideshowData.length - 1
        const unit = 100 / (this.slideshowData.length - 1)
        if (this.selectDate % unit > (unit / 2)) {
            this.selectDate = (Math.floor(this.selectDate / unit) + 1) * unit
        } else {
            this.selectDate = Math.floor(this.selectDate / unit) * unit
        }
        this.index = Math.round((this.selectDate / 100) * dataLength)
        if (this.index != this.previousIndex) {
            const valueSlider = {
                'sliderClientTop': this.selectDate,
            }
            this.clientTopServices.emitChangeSlider(valueSlider)
            this.previousIndex = this.index
        }
    }

}



// WEBPACK FOOTER //
// ./src/app/app_manager/modal/client-detail/top/slideshow/slideshowDSD/modal-client-detail-slideshow-dsd.component.ts